
//common function for ajax call...............
function showPrev(event) {
    var el = $(event.target);
    // console.log(el);
    var elW = $(el).innerWidth();
    var wiW = $(document).innerWidth();
    var matchWidth = (wiW - elW) / 2;
    var posl = $(el).find('.owl-stage').position().left;
    // console.log(Math.abs(posl));
    var currentItem = event.item.index;
    $(el).find('.owl-stage .owl-item').removeClass('current')
    $(el).find('.owl-stage .owl-item').eq(currentItem).addClass('current');
    if (matchWidth < Math.abs(posl)) {
      $(el).find('.owl-prev').addClass('show');
    } else {
      $(el).find('.owl-prev').removeClass('show');
    }
  };

function currentItem(event) {
    var el = $(event.target);
    // console.log(el);
    var currentItem = event.item.index;
    $(el).find('.owl-stage .owl-item').removeClass('current')
    $(el).find('.owl-stage .owl-item').eq(currentItem).addClass('current');
};

function currentOnHover(event) {
    var el = $(event.target);
    $(el).find('.owl-stage .owl-item').on('mouseover', function (e) {
      $(el).find('.owl-stage .owl-item').removeClass('current');
      if ($(this).is('.currentOnHover')) return;
      $(el).find('.owl-stage .owl-item').removeClass('currentOnHover');
      $(this).addClass('currentOnHover');
    })
};

function ajaxForm(url, form_id, append_data, method) {
    if (typeof (method) === 'undefined') method = 'post';
    if (typeof (append_data) === 'undefined') append_data = '';
    if (typeof (form_id) === 'undefined') form_id = '';
    url = assetBaseUrl + url;
    var fd = $(form_id)[0];
    var form_data = new FormData(fd);
    if (append_data !== '') {
        $.each(append_data, function (key, value) {
            form_data.append(key, value);
        });
    }
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: method,
            url: url,
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function(data){
                $('#loader').css('display','block');
            },
            statusCode: {
                419: function () {
                    location.href = assetBaseUrl;
                },
                401: function () {
                    location.href = assetBaseUrl;
                }
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                $('#loader').css('display','none');
                resolve(data);
            },
            error: function (error) {
                $('#loader').css('display','none');
                reject(error);
            }
        });
    });
};

//send otp function
// function sendotp(countryCode, mobileNumber) {
function sendotp(mobileNumber,otpRequestBy="") {
    $.ajax({
        url: assetBaseUrl + "send-otp",
        type: 'post',
        data: {'mobile_no': mobileNumber,'otpRequestBy' : otpRequestBy},
        // data: {'mobile_no': mobileNumber },
        beforeSend: function(data){
            $('#loader').css('display','block');
        },
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
        },
        success: function (data) {
            $('#loader').css('display','none');
            if (data.error) {
                if(data.notRegister) {
                    sweetInfoPopUpWithTitle(data.msg,"");

                    SignUpClicked('New Mobile Number');
                    var mobile = mobileNumber.slice(-10);
                    $('#mobileNumber1').data('value',mobileNumber);
                    $('#mobileNumber1').val(mobile);
                    // $('#countryCode1').val(countryCode);
                    $("label[for='mobileNumber1']").css('display','none');
                    $('#register-popup').css('display', 'block');
                    $('#login-popup').css('display', 'none');
                    getPinCodeStateName();
                }
                else{
                    sweetErrorPopUpWithTitle(data.msg);

                }
                // $('.label_msg_error').removeAttr('hidden');
                // $('.label_msg_error').html(data.msg);
            } else {
                sweetSuccessPopUpWithTitle(data.msg);
                OTPViewed('Mobile',mobileNumber);
                // Hide Generate OTP Pop-up

                // Show Verify OTP Pop-up
                // $('#mobileInoBox').html(countryCode + " " + mobileNumber);
                $('#mobileInoBox').html(mobileNumber);
                // $('#country_code').val(countryCode);
                $('#mobile_no').val(mobileNumber);
                $('#isEmailLogin').val(0);
                $('#verify-login-otp').css('display', 'block');
                checkAnOtherPopup = false;
                $('#login-popup').css('display', 'none');
                timer(900);
                $('input#otp-part-1').focus();
                $('#usr_code').val(data.user_code);
            }
        },
    });
}
//send email otp function
function sendEmailOtp(email) {
    $.ajax({
        url: assetBaseUrl + "send-email-otp",
        type: 'post',
        data: { 'email': email },
        beforeSend: function(data){
            $('#loader').css('display','block');
        },
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
        },
        success: function (data) {
            $('#loader').css('display','none');
            if (data.error) {
                sweetErrorPopUpWithTitle(data.msg);
                if(data.notRegister) {
                    SignUpClicked('New Email ID');
                    $('#email').val(email);
                    $("label[for='email']").css('display','none');
                    $('#register-popup').css('display', 'block');
                    $('#email-login-popup').css('display', 'none');
                    getPinCodeStateName();
                }
            } else {
                sweetSuccessPopUpWithTitle(data.msg);
                OTPViewed('email',email );
                // Hide Generate OTP Pop-up
                $('#email-login-popup').css('display', 'none');

                // Show Verify OTP Pop-up
                $('#mobileInoBox').html(email);
                $('#optTextBox').html('OTP has been sent to your Email ID');
                $('#isEmailLogin').val(1);
                
                $('#verify-login-otp').css('display', 'block');
                checkAnOtherPopup = false;
                timer(900);
                $('input#otp-part-1').focus();
            }
        },
    });
}
countDownClick = 0; 
rem = -1;
function timer() {
    $('.resend-otp').attr('disabled', true);
    ds(0);
    countDownClick = 1;
    document.getElementById('otp-expires-time').innerHTML = 'OTP expires in <strong id="otp-expiry">15:00</strong> minutes';
}
function ds(remaining ){
    $('.resend-otp').attr('disabled', true);
   
    if(countDownClick > 0 ) {
        countDownClick = 0;
        ds(900);
        return;
    }
    if(countDownClick == 0 && rem < 0){
        countDownClick = 1;
        rem =900;
        ds(900);
        return;
    }
    let timerOn = true;
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    document.getElementById('otp-expires-time').innerHTML = 'OTP expires in <strong id="otp-expiry">' + m + ':' + s + '</strong> minutes';
    remaining -= 1;
    rem = remaining;
    if (remaining >= 0 && timerOn) {
        setTimeout(function () {
            ds(remaining);
        }, 1000);
        return;
    }

    if (!timerOn) {
        // Do validate stuff here
        return;
    }
    $('.resend-otp').attr('disabled', false);
    // Do timeout stuff here
    document.getElementById('otp-expires-time').innerHTML = '<strong>OTP has been expired</strong>';
}

// Restrict text boxes by passing ID and regex
function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
    textbox.addEventListener(event, function() {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
            this.value = "";
        }
        });
    });
}

// get pin code state names
function getPinCodeStateName() {
    $.ajax({
        url : assetBaseUrl + "pin-code-states-name",
        type: 'post',
        //data:{'param':'all'},
        success: function(data){
            //console.log(data.pincodes);
            if(data.error) {
                sweetErrorPopUpWithTitle(data.msg);
            } else {
                $("#state_name").append('<option value=' + '' + '>Please Select</option>');
                $.each(data.pincodes,function(key, value)
                {
                    $("#state_name").append($('<option>').val(value).text(value));
                });
            }
        }
   });
}
  
$(document).ready(function () {
    $("#upload-document").change(function(){
        $("#uploadInputLabel").hide();
        $("#prog").show().delay(1000).fadeOut();
        $("#tickmarkk").delay(2000).fadeIn();
        $("#tickmarkk").delay().fadeOut();
        $("#documentSec").delay(2800).fadeIn(2800);
        $(".uploadContext input").hide();
    });

    $('#upload-document').change(function(e) {
        var file = e.target.files[0].name;
        $("#fileName").text(file);
    });

    $('.okBtn').click(function() {
        $(".btnCancelAlter").removeClass('showPop');
        // location.reload();
        $("#uploadInputLabel").show();
        $(".uploadContext input").show();
        $("#documentSec").hide();
        $('#upload-document').val('');
        $('#upload-document').removeClass('error');
    });

    $('.cancelbtn').click(function() {
        $(".btnCancelAlter").removeClass('showPop');
    });
    $('.deletebtn').click(function() {
        $(".btnCancelAlter").addClass('showPop');
    });
    $('.address-click').click(function() {
        alert($("#upload-document").hasClass("error"));
    });
   

    // $.validator.addMethod("mobile_validation", function(value, element) {
    //     return this.optional(element) || value == value.match(/(\+\d{1,3}[- ]?)?\d{10}$/);
    // }, "Please enter valid mobile number.");

    // generate OTP
    // generateOTP mobileNumber countryCode

    // setInputFilter(document.getElementById("countryCode"), function(value) {
    //     // return /^-?\d*[.,]?\d{0,2}$/.test(value); });
    //     return /^[0+]?\d{0,3}$/.test(value);
    // });
    // setInputFilter(document.getElementById("countryCode1"), function(value) {
    //     // return /^-?\d*[.,]?\d{0,2}$/.test(value); });
    //     return /^[0+]?\d{0,3}$/.test(value);
    // });
    $('#mobile-login-form').validate({
        rules: {           
            'mobile': {
                required: true,
                minlength: 4,
                maxlength: 15,
                number: true,
            }
        },
        errorPlacement: function (error, element) {
            var msg = error.text();
            if (error) {
                // console.log(error);
                element.parents('.form-group').find('.error_text').text(msg);
            } else {
                element.parents('.form-group').find('.error_text').text("");
            }
        },
        submitHandler: function (form) {
            // var countryCode = $('#countryCode').val();
            //console.log("mobileNumber = ", validMobNo, " valid = ", isMobValid);
            // console.log("Mobile " + mobileNumber);
            // sendotp(countryCode, mobileNumber);
            if(isMobValid) {
                generateOTPClicked('mobile', validMobNo);
                sendotp(validMobNo);   
            }
        }
    });
 
    // email login form 
    $('#email-login-form').validate({
        rules: {
            'email': {
                required: true,
                email: true,
                email_validation: true,
            }
        },
        errorPlacement: function (error, element) {
            var msg = error.text();
            if (error) {
                // console.log(error);
                element.parent().find('.error_text').text(msg);
            } else {
                element.parent().find('.error_text').text("");
            }
        },
        submitHandler: function (form) {
            var email = $('#emailID').val();
            generateOTPClicked('email', email);
            sendEmailOtp(email);
        }
    });

    //register form submit with validation
    $('#register-form').validate({
        rules: {
            'first_name': {
                required: true,
                maxlength: 64,
            },
            'last_name': {
                required: true,
                maxlength: 64,
            },
            'email': {
                required: true,
                email: true,
                email_validation: true,
            },
            'mobile_no': {
                required: true,
                minlength: 4,
                maxlength: 15,
                number: true,
            },
            'pin_code': {
                required: true,
                minlength: 3,
                maxlength: 8,
                number: true,
            },
            'city_name': {
                required: true,
                maxlength: 64,
            },
            'state_name': {
                required: true,
                maxlength: 64,
            },
        },
        errorPlacement: function (error, element) {
            var msg = error.text();
            if (error) {
                // console.log(error);
                element.parents('form-group').find('.error_text').text(msg);
            } else {
                element.parents('form-group').find('.error_text').text("");
            }
        },
        submitHandler: function (form) {
            var mobileNo = $('#mobileNumber1').data('value');
            // alert(mobileNo);
            var fName = $('#first_name').val();
            var lName = $('#last_name').val();
            var email = $('#email-reg').val();
            var pin_code = $('#pin_code').val();
            var city_name = $('#city_name').val();
            var state_name = $('#state_name').val();
            let obj_form = $(form).serializeArray(); 
            // obj_form.forEach(function (input) { 
            //     console.log(input.name + ":" + input.value); 
            // }) 
            console.log(obj_form);
            // email = obj_form['email'];
            // alert(email);
            var params={'First Name':fName,'Last Name': lName,'Email': email,'Mobile No': mobileNo,
            'Pincode': pin_code,'City': city_name,'State': state_name};
            ClubMahindraGALeadForm('re_signup_form_submit');
            submitSignUp(params);
            $.ajax({
                url: assetBaseUrl + "register",
                type: 'post',
                data: {'first_name':fName,'last_name': lName,'email': email,'mobile_no': mobileNo,'pin_code': pin_code,'city_name': city_name,'state_name': state_name},
                // data: {'mobile_no': mobileNumber },
                beforeSend: function(data){
                    $('#loader').css('display','block');
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
                },
                success: function (data) {
                    $('#loader').css('display','none');
                    if (data.error) {
                        sweetErrorPopUpWithTitle(data.msg);
                    } else {
                        sweetSuccessPopUpWithTitle(data.msg);
                        $('#register-popup').css('display', 'none');
                        $('.mobileNumber').data('value',mobileNo);
                        $('#login-popup').css('display', 'block');
                    }
                },
            });
        }
    });

    // Verify login  OTP
   
    // generateOTP mobileNumber countryCode
    $('#verify-login-otp-btn').click(function (e) {
        var isValid;
        var mobile_text = $('#mobileInoBox').text();
        var trim_str = mobile_text.replace(" ", "");
        var f_mobile = trim_str.replace("+", "");
        console.log(f_mobile)
        var usr_code = $('#usr_code').val();
        var country_code = $("#country_code").val();
        var mob_no = $("#mobile_no").val(); 
        var otp = '';
        $("input.loginOtpDigitBox").each(function () {
            let element = $(this);
            let param = $(this).val();
            otp += param;
            if ($.trim(element.val()) == "") {
                isValid = false;
            }
        });
       // var captcha = $('#g-recaptcha-response').val();
        if (isValid == false) {
            otpProceedClicked("Please fill otp correctly",mobile_text);
            sweetErrorPopUpWithTitle("Please fill otp correctly");
        } 
        // else if(captcha == ''){
        //     sweetErrorPopUpWithTitle("Please check Captcha","Error !");
        // } 
        else {
            var isEmailLogin = $('#isEmailLogin').val();
            // console.log(isEmailLogin);
            // console.log(f_mobile);
            if(isEmailLogin == 1) {
                $.ajax({
                    url: assetBaseUrl + "verify-email-otp",
                    type: 'post',
                    data: { 'email': f_mobile, 'otp': otp },
                    beforeSend: function(data){
                        $('#loader').css('display','block');
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
                    },
                    success: function (data) {
                        if (data.error) {
                            // grecaptcha.reset();
                            otpProceedClicked(data.msg,mobile_text);
                            sweetErrorPopUpWithTitle(data.msg);
                        } else {
                            otpProceedClicked(data.msg,mobile_text);
                            $('#verify-login-otp').css('display', 'none');
                            // alert(window.location.href + " -:- " + $('form#redirectFormToUploadView').attr('current-route'));
                            // Hide Generate OTP Pop-up
                            $('#verify-login-otp-btn').attr('disabled', true);
                            if(window.location.href == $('#userProductURL').val() && $('#payment_clk').val() == '1' && $('#tnc_chk').val() == '1') {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#is_active').val('yes');
                                $('#makePayBtn').click();
                            } else if(window.location.href == $('#userProductURL').val()) {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#is_active').val('yes');
                                window.location.href = $('#userProductURL').val();
                            } else if(window.location.href == $('form#redirectFormToUploadView').attr('current-route') ) {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#loader').css('display','none');
                                $('form#redirectFormToUploadView').submit();
                            } else if(window.location.href == $('#kycEsignInput').val()) {
                                var esign = $('.kyc-box').data('src');
                                $.ajax({
                                    url: assetBaseUrl + "ekyc/store-esign",
                                    type: 'post',
                                    data: { 'esign': esign },
                                    beforeSend: function(data){
                                        $('#loader').css('display','block');
                                    },
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
                                    },
                                    success: function (data) {
                                        $('#loader').css('display','none');
                                        if (data.error) {
                                            grecaptcha.reset();
                                            sweetErrorPopUpWithTitle(data.msg);
                                        } else {
                                            sweetSuccessPopUpWithTitle(data.msg);
                                            window.location.href = assetBaseUrl + 'ekyc/kyc-success';
                                            $('#loader').css('display','block');
                                        }
                                    }
                                });
                            } else {
                                sweetSuccessPopUpWithTitle(data.msg);
                                window.location.href = assetBaseUrl;
                            }
                        }
                        $('#loader').css('display','none');

                    },
                });
            } else {
                $.ajax({
                    url: assetBaseUrl + "verify-otp",
                    type: 'post',
                    data: { 'mobile_no': f_mobile, 'user_code': usr_code, 'otp': otp },
                    beforeSend: function(data){
                        $('#loader').css('display','block');
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
                    },
                    success: function (data) {
                        if (data.error) {
                            // grecaptcha.reset();
                            otpProceedClicked(data.msg,mobile_text);
                            sweetErrorPopUpWithTitle(data.msg);
                            // $('#loader').css('display','none');
                            // $('.label_msg_error').removeAttr('hidden');
                            // $('.label_msg_error').html(data.msg);
                        } else {
                            otpProceedClicked(data.msg,mobile_text);
                            $('#verify-login-otp').css('display', 'none');
                            // otpProceedClicked(country_code,mob_no);
                            // Hide Generate OTP Pop-up
                            $('#verify-login-otp-btn').attr('disabled', true);
                            if(window.location.href == $('#userProductURL').val() && $('#payment_clk').val() == '1' && $('#tnc_chk').val() == '1') {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#is_active').val('yes');
                                $('#makePayBtn').click();
                            } else if(window.location.href == $('#userProductURL').val()) {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#is_active').val('yes');
                                window.location.href = $('#userProductURL').val();
                            } else if(window.location.href == $('form#redirectFormToUploadView').attr('current-route') ) {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#loader').css('display','none');
                                $('form#redirectFormToUploadView').submit();
                            } else if(window.location.href == $('#kycEsignInput').val()) {
                                var esign = $('.kyc-box').data('src');
                                $.ajax({
                                    url: assetBaseUrl + "ekyc/store-esign",
                                    type: 'post',
                                    data: { 'esign': esign },
                                    beforeSend: function(data){
                                        $('#loader').css('display','block');
                                    },
                                    headers: {
                                        'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
                                    },
                                    success: function (data) { 
                                        if (data.error) {
                                            $('#loader').css('display','none');
                                            grecaptcha.reset();
                                            sweetErrorPopUpWithTitle(data.msg);
                                        } else {
                                            $('#verify-login-otp').css('display', 'none');
                                            sweetSuccessPopUpWithTitle(data.msg);
                                            $('#loader').css('display','block');
                                            window.location.href = assetBaseUrl + 'ekyc/kyc-success';
                                        }
                                    }
                                });
                            } else {
                                sweetSuccessPopUpWithTitle(data.msg);
                                $('#loader').css('display','none');
                                // $('.with-login').css('display','block');
                                window.location.href = assetBaseUrl;
                            }
                        }
                        $('#loader').css('display','none');

                    },
                });
            }
        }
    });

    //resend OTP
    $(document).on('click', '.resend-otp', function (e) {
        var mobile_text = $('#mobileInoBox').text();
        var trim_str = mobile_text.replace("+", "");
        var res_split = trim_str.split(" ");
        var countryCode = res_split[0];
        var otpRequestBy= '';
        var otpRequestBystr= $(location).attr('pathname');
        
        if(otpRequestBystr.indexOf('esign') != -1){
            otpRequestBy= 'esign';
        }
        ResendOTPClicked(mobile_text);
        $.ajax({
            url: assetBaseUrl + "resend-otp",
            type: 'post',
            data: { 'country_code': countryCode, 'mobile_no': countryCode ,'otpRequestBy' : otpRequestBy},
            beforeSend: function(data){
                $('#loader').css('display','block');
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
            },
            success: function (data) {
                $('#loader').css('display','none');
                if (data.error) {
                    sweetErrorPopUpWithTitle(data.msg);
                    // $('.label_msg_error').removeAttr('hidden');
                    // $('.label_msg_error').html(data.msg);
                } else {
                    $('.resend-otp').attr('disabled', true);
                    timer(900);
                    sweetSuccessPopUpWithTitle(data.msg);
                    console.log("resend otp successfully");
                }
            },
        });
    });
    
    //Function to verify mobile number with country code
    function mobileVerifyWithMsg(contry_code, mobile_no, contry_mobile) {
        var pattern = new RegExp(/^(\+\d{1,3}[- ]?)?\d{10}$/);
        if (contry_code.trim() == '' || mobile_no.trim() == '') {
            sweetErrorPopUpWithTitle("Please fill the required fields");
            // $('.label_msg_error').removeAttr('hidden');
            // $('.label_msg_error').html('Please fill the required field');
            return false;
        }
        if (pattern.test(contry_mobile) === false) {
            sweetErrorPopUpWithTitle("Please Enter Valid Mobile Number");
            // $('.label_msg_error').removeAttr('hidden');
            // $('.label_msg_error').html('Please Enter Valid Mobile Number');
            return false;
        }
        return true;
    }

    function video_img_popup(content1, content2) {
        $.fancybox.open([
            {
                src: content1,
                opts: {
                    caption: 'First caption',
                    thumb: content2
                }
            },
        ], {
            loop: true,
            thumbs: {
                autoStart: true
            }
        });
    }

    $('.video-section').on('click', '.img-container', function () {
        var video = $(this).find('#video-data').val();
        var thumb_img = $(this).find('#image-data').val();
        video_img_popup(video, thumb_img);
    });

    //auto search on ajax
    $(".search-box").keyup(function () {
        // if ($(this).val().length >= 3) {
        //     var param = $(this).val();
        //     var resortSlides = '';
        //     ResortListPageSearchClicked(param);
        //     $.ajax({
        //     url : assetBaseUrl + "auto-search",
        //     type: 'post',
        //     data:{'param':param},
        //     success: function(data){
        //         if(data.error) {
        //         sweetErrorPopUpWithTitle(data.msg);
        //         } else {
        //         if(data.search_res.length > 0) {
        //             $.each(data.search_res, function(key, value) {
        //                 if(key < 6) {
        //                     var regex = new RegExp(param, 'gi');
        //                     if(value._source.resort_location.search(regex) != -1) {
        //                         var resort_loc = value._source.resort_location.replace(regex,"<b>$&</b>");
        //                     } else {
        //                         var resort_loc = value._source.resort_location;
        //                     }
        //                     resortSlides += '<li><div class="resort-image"><a href="'+assetBaseUrl+"resort/"+value._source.slug+'"><img src="'+data.img_url+value._source.resort_banner+'" style="width:62px;height:62px;"/></a></div>'+
        //                     '<div class="resort-content"><strong>'+value._source.resort_name+'</strong>'+
        //                     '<span class="resort_location">'+resort_loc+'</span></div></li>';
        //                 }
        //             });
        //         } else {
        //             resortSlides = '<i>There is no record found !</i>';
        //         }
        //         $('.popular-res').css('display','none');
        //         $('.auto-search-resorts').html(resortSlides);
        //         }
        //     }
        //     });
        // }
        // if ($(this).val().length == 0) {
            var param = $(this).val();
            var resortSlides = '';
            $.ajax({
                url: assetBaseUrl + "autofilterResorts",
                type: 'post',
                data: { 'param': param },
                success: function (data) {
                    console.log(data);
                    // console.log(JSON.stringify(data.resorts).length);
                    if (data.error) {
                        sweetErrorPopUpWithTitle(data.msg);
                    } else {
                        if (JSON.stringify(data.resorts).length > 0) {
                            var i=0;
                            $.each(data.resorts, function (key, value) {
                               
                                if(i < 6) { 
                                    i++;
                                    var regex = new RegExp(param, 'gi');
                                    
                                    var city_name = (typeof value.city !== 'undefined') ? value.city + ',' : '';
                                    var state_name = (typeof value.state !== 'undefined') ? value.state + ',' : '';
                                    var locStr=city_name + " " + state_name;
                                    if(locStr.search(regex) != -1) {
                                        var resort_loc = locStr.replace(regex,"<b>$&</b>");
                                    } else {
                                        var resort_loc = locStr;
                                    }
                                    resortSlides += '<li><div class="resort-image"><img src="' + data.img_url + value.resort_banner + '" style="width:62px;height:62px;"/></div>' +
                                    '<div class="resort-content"><strong>' + value.resort_name + '</strong>' +
                                    '<span class="resort_location">' + resort_loc + '</span></div></li>';
                                    // co/nsole.log(resortSlides);
                                }    
                            });
                        } else {
                            resortSlides = '<i>There is no record found !</i>';
                        }
                        $('.popular-res').css('display', 'block');
                        $('.auto-search-resorts').html(resortSlides);
                    }
                }
            });
        // }
    });

    function owl_carousl_resorts($owl) {
        $owl.owlCarousel({
            nav: false,
            dots: false,
            items: 6,
            margin: 23,
            autoWidth: true,
            navText: [
                "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>",
                "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"
            ],
            responsive: {
                0: {
                    items: 1.2
                },
                1025: {
                    items: 3.5,
                    nav: true
                }
            },
            onTranslated: showPrev,
            onDraged: showPrev,
            onInitialized: currentItem,
            onRefresh: currentOnHover
        });
    }

    //register popup open 
    $('.signup-click').click(function (e) {
        $("#register-form")[0].reset();
        $('#register-popup').css('display', 'block');
        $('#login-popup').css('display', 'none');
        $('#email-login-popup').css('display', 'none');
        getPinCodeStateName();
    });
    
    /*Tabing section js */
    $('.listing .col').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.listing .col').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
    })
    /*Tabing section js */

    //login popup open 
    $(document).on('click', '#login-clk', function(e) {
        // alert('hi');
    // $('#login-clk').click(function (e) {
        $("#mobile-login-form")[0].reset();
        $('#login-popup').css('display', 'block');
        $('#register-popup').css('display', 'none');
        $('#email-login-popup').css('display', 'none');
    });
     //login popup open 
     $('#email-login-click').click(function (e) {
        $("#email-login-form")[0].reset();
        $('#email-login-popup').css('display', 'block');
        $('#login-popup').css('display', 'none');
    });

      // generateOTP mobileNumber countryCode
      $('input.loginOtpDigitBox').on('keyup', function(e) {
        let cVal = $(this).val();
        let cPart = $(this).attr('id');
        if ($('#otp-part-1').val() != '' && $('#otp-part-2').val() != '' && $('#otp-part-3').val() != '' && $('#otp-part-4').val() != '' && $('#otp-part-5').val() != '' && $('#otp-part-6').val() != '') {
          $('#verify-login-otp-btn').attr('disabled', false);
        } else {
          $('#verify-login-otp-btn').attr('disabled', true);
        }
        if ($.trim(cVal) != '') {
          if ($.trim(cPart) != '' || $.trim(cPart) != undefined) {
            let cPartArr = cPart.split('-');
            if (cPartArr[cPartArr.length - 1] < 6) {
              let nextD = parseInt(cPartArr[cPartArr.length - 1]) + 1;
              $('input#otp-part-' + nextD).focus();
            }
          }
        }
      });
      // Verify login  OTP
      // generateOTP mobileNumber countryCode
      $('input.loginOtpDigitBox').on('keyup', function(e) {
        let cVal = $(this).val();
        let cPart = $(this).attr('id');
        if ($.trim(cVal) != '') {
          if ($.trim(cPart) != '' || $.trim(cPart) != undefined) {
            let cPartArr = cPart.split('-');
            if (cPartArr[cPartArr.length - 1] < 6) {
              let nextD = parseInt(cPartArr[cPartArr.length - 1]) + 1;
              $('input#otp-part-' + nextD).focus();
            }
          }
        }
      });
  
      $(document).on('click', '.login-signup', function(e) {
        e.preventDefault();
        if ($(this).attr('is-logged') == 'false') {
          $('#login-popup').css('display', 'block');
          $('input#countryCode').focus();
        } else {
          $('#login-popup').css('display', 'block');
          $('input#countryCode').focus();
        }
      });

    //lead form submit with validation
    $('#exit-intent-form').validate({
        rules: {
            'name': {
                required: true,
            },
            'email': {
                required: true,
                email: true,
                email_validation: true,
            },
            'mobile_no': {
                required: true,
                minlength: 4,
                maxlength: 15,
                number: true,
            }
        },
        errorPlacement: function (error, element) {
            var msg = error.text();
            if (error) {
                // console.log(error);
                element.parents('form-group').find('.error_text').text(msg);
            } else {
                element.parents('form-group').find('.error_text').text("");
            }
        },
        submitHandler: function (form) {
            var mobileNo = $('#mobileNumber2').data('value');
            var fName = $('#fname').val();
            var email = $('#email_id').val();
            $.ajax({
                url: assetBaseUrl + "store-lead",
                type: 'post',
                data: {'name':fName,'email': email,'mobile_no': mobileNo},
                beforeSend: function(data){
                    $('#loader').css('display','block');
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
                },
                success: function (data) {
                    $('#loader').css('display','none');
                    if (data.error) {
                        sweetErrorPopUpWithTitle(data.msg);
                    } else {
                        leadFormSubmissionOnClever();
                        sweetSuccessPopUpWithTitle(data.msg);
                        $('#lead-popup').css('display', 'none');
                        $('#default-popup').css('display', 'block');
                    }
                },
            });
        }
    });  

    $('.mobwhatsappbtn').click(function() {
        $('.callBack').addClass('showwhatsappop');
      });
      $('.closearrow').click(function() {
        $('.callBack').removeClass('showwhatsappop');
        $('body').removeClass('overflowHidden');

      });

    $(document).on("submit", '#callus-form', function (e) {
        e.preventDefault();
        var mob=$('#mobileNumber').data('value'),
            name=$('#full_name').val();
        callWithUsSubmitClick(name,mob);
        // console.log($(this).serialize());
        $.ajax({
            type: "post",
            url: assetBaseUrl + "callus",
            data: $(this).serialize()+ '&mobile_no=' + $('#mobileNumber').data('value'),
            beforeSend: function (data) {
                $('#loader').css('display', 'block');
            },
            success: function (data) {
                $('#loader').css('display', 'none');
                console.log(data.error);
                if (data.error) {
                  $('.thank_section').css('display', 'none');
                  $('.error-form').html(data.msg);
                } else {
                  $('.callback_form').css('display', 'none');

                  $('.thank_section').css('display', 'block');
                }
            }
        });
    });

    $(document).on('click', '.book_holiday', function(e) {
        e.preventDefault();
        var memberId = $('#memberId').val();
        $.ajax({
            type: "post",
            url: assetBaseUrl + "sso_login",
            data: {'memberId':memberId},
            beforeSend: function (data) {
                $('#loader').css('display', 'block');
            },
            success: function (data) {
                $('#loader').css('display','none');
                if (data.error) {
                    sweetErrorPopUpWithTitle(data.msg);
                } else {
                    window.open(data.redirect_url, '_blank');
                }
            }
        });
    });
    
    $("#city_name").focus(function(){
        $("#pin_error").css("display", "none");
    });

    //pincode auto search on ajax
    $("#pin_code").keyup(function () {
        var param = $(this).val();
        var pinCodes = '';
        if(param.length > 3) {
            $.ajax({
             url : assetBaseUrl + "pin-code-search",
             type: 'post',
             data:{'param':param},
             success: function(data){
                 var pincodes = (data.pincodes) !="" ? JSON.parse(data.pincodes) : "";
                 if(data.error) {
                    sweetErrorPopUpWithTitle(data.msg);
                 } else {
                    if(pincodes.length > 0) {
                        $.each(pincodes, function(key, value) {
                                pinCodes += '<div id="sel_pin_'+value+'" class="sel_pin_code" onclick="pincodeClick(\'' + value + '\');" style="cursor: pointer;"><span>'+value+'</span></div>';
                        });
                    } else {
                        pinCodes = '<div id="pin_error">Please enter valid PINCODE</div>';
                        // $('#cityNames').css('display','block');
                        // $('#stateNames').css('display','block');
                        //  $('#newShowState').css('display','flex');
                    }
                    $('.auto-search-pincode').show();
                    $('.auto-search-pincode').html(pinCodes);
                 }
                 // auto fetch city and state once pincode enter
                 if(param.length == 6) {
                     var pin = $('#pin_code').val();
                     //$('.auto-search-pincode').hide();
                     pincodeClick(pin);
                 } else {
                    // cleare the city and state fields
                    $('#city_name').val('');
                    $('#state_name').val('');
                 }
             }
           });
        } else {
            // $('#cityNames').css('display','none');
            // $('#stateNames').css('display','none');
            $('#newShowState').css('display','none');
            $('.auto-search-pincode').hide();
            $('#city_name').val('');
            $('#state_name').val('');
        }
    });

});

// append city and state on click of pincode
function pincodeClick(pincode) {
    $.ajax({
        url : assetBaseUrl + "pin-code-result",
        type: 'post',
        data:{'param':pincode},
        success: function(data){
            if(data.error) {
               //sweetErrorPopUpWithTitle(data.msg);
               pinCodes = '<div id="pin_error">Please enter valid PINCODE</div>';
               setTimeout(function() {
                $('#pin_error').fadeOut();
            }, 1000);
            //    $('#cityNames').css('display','block');
            //    $('#stateNames').css('display','block');
            //    $('#newShowState').css('display','flex');
               $('.auto-search-pincode').show();
               $('.auto-search-pincode').html(pinCodes);
            } else {
                var str = data.pincodes.city_name;
                str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                    return letter.toUpperCase();
                });
                $('#cityNames').addClass('labelTopName');
                $('#pin_code').val(data.pincodes.pincode);
                $('#city_name').val(str);
                $('#state_name').val(data.pincodes.state_name);
                $('.auto-search-pincode').hide();
            }
        }
      });
}



////  code for the GA4 implementation 

window.dataLayer = window.dataLayer || [];

function maskemailid(email) {
    var maskedid = "";
    var myemailId = email;
    var index = myemailId.lastIndexOf(".");
    var prefix = myemailId.substring(0, index);
    var postfix = myemailId.substring(index);
    var mask = prefix.split('').map(function (o, i) {
        if (i < 3 || i == (index - 0)) {
            return o;
        } else {
            return '*';
        }
    }).join('');

    maskedid = mask + postfix;
    return maskedid;
}


function referalurl() {
    referal = document.referrer.split(document.domain).pop().split('?')[0];
    return referal;
}

function ClubMahindraGA4(eventName, obj, subheader) {
    subheader = header_clicked_text = sub_header_clicked_text = 'NA';
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    subheader = obj.getAttribute('subheader') ? obj.getAttribute('subheader') : 'NA';
    header_clicked_text = obj.title;
    sub_header_clicked_text = subheader;
    window.dataLayer.push({
        'event': eventName,
        'header_clicked_text': header_clicked_text,
        'sub_header_clicked_text': sub_header_clicked_text,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });


}

function ClubMahindraGALogin(eventName)
{
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    }); 
}

function ClubMahindraGASecondformate(eventName) {
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
}

function ClubMahindraGAOutbond(eventName, obj) {
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'outbound_clicked_text': obj.title,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
}

function ClubMahindraGALeadForm(eventName) {
    var mobileNo = $('#mobileNumber1').data('value');
    // alert(mobileNo);
    var fName = $('#first_name').val();
    var lName = $('#last_name').val();
    var email = $('#email').val();
    var pin_code = $('#pin_code').val();
    var city_name = $('#city_name').val();
    var state_name = $('#state_name').val();
    locations = city_name+" , "+state_name;
    mobile = mobileNo.replace(/\d(?=\d{4})/g, "*");
    email = maskemailid($('#email').val());
    names = fName+" "+lName;
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'email': email,
        'mobile': mobile,
        'location': locations,
        'pincode': pin_code,
        'is_member': is_member,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
  
}


function ClubMahindraGAReMakePayment(obj) {
    eventName = 're_make_payment_clicked';
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'total_amount': obj.title,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
}

// Banner Ga4 event 

function ClubMahindraGABanner(obj) {

    eventName = 'banner_clicked';
    utm_medium = utm_source = "";
    banner_title = obj.title;
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'banner_name': banner_title,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });

}

function ClubMahindraGAResort(eventName, obj) {
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'resort_name': obj.title,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });

}

function ClubMahindraGAFilter(obj) {
    eventName='resort_clicked_via_filter';
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    resortName = obj.getAttribute('subheader') ? obj.getAttribute('subheader') : 'NA';
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'is_member': is_member,
        'filters_applied': obj.title,
        'resort_name': resortName,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
}

    function ClubMahindraGAFilterApply(eventName, zone ,terrain) {

        var AppliedFilter = zone+','+terrain;
        var utm_medium = utm_source = "";
        var source = referalurl();
        var lob = window.location.pathname;
        var is_member = 'No';
        var QueyString = location.search;
        var urlParams = new URLSearchParams(location.search);
        for ([key, value] of urlParams) {
            if (key == 'utm_medium') {
                utm_medium = value;
            } else if (key == 'utm_source') {
                utm_source = value;
            }
        }
        window.dataLayer.push({
            'event': eventName,
            'source': source,
            'lob': lob,
            'is_member': is_member,
            'filters_applied': AppliedFilter,
            'utm_medium': utm_medium,
            'utm_source': utm_source
        });

    }

    function ClubMahindraGAmobileOtp(eventName,obj) {
        
    mobileNo = obj.title;
    mobile = mobileNo.replace(/\d(?=\d{4})/g, "*");
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'mobile': mobile,
        'is_member': is_member,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
}

function ClubMahindraGAEmailOtp(eventName) {
    email = maskemailid($("#emailID").val());
    utm_medium = utm_source = "";
    source = referalurl();
    lob = window.location.pathname;
    is_member = 'No';
    QueyString = location.search;
    urlParams = new URLSearchParams(location.search);
    for ([key, value] of urlParams) {
        if (key == 'utm_medium') {
            utm_medium = value;
        } else if (key == 'utm_source') {
            utm_source = value;
        }
    }
    window.dataLayer.push({
        'event': eventName,
        'source': source,
        'lob': lob,
        'email':email,
        'is_member': is_member,
        'utm_medium': utm_medium,
        'utm_source': utm_source
    });
}
function getmobile(obj){
    mobileNo = obj.getAttribute('data-value');
    $("#mobile-no").attr("title",mobileNo);
}